import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { FaTimes } from 'react-icons/fa';
import ToolTip from './ToolTip/ToolTip';
const styles = {
    button: {
        backgroundColor: 'transparent',
        border: 'none',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    svg: {
        fill: '#ca0000',
        fontSize: '16px',
    },
};
function CloseButton(props) {
    const { onClick = () => null, popupTitle = 'Close', popupPlacement = 'left', className = '', } = props;
    return (_jsx("div", { className: className, children: _jsx(ToolTip, { title: popupTitle, popupPlacement: popupPlacement, children: _jsx("button", { style: styles.button, type: "button", onClick: onClick, children: _jsx(FaTimes, { style: styles.svg }) }) }) }));
}
export default memo(CloseButton);
